import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import { Badge, IconButton, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { NAV_ROUTES } from "components/NavigationBar/routes";

import { useRoleContext } from "../../hooks";
import { useCompanyProfile } from "../../hooks/useCompanyProfile";

export function CompanyProfileButton() {
  const navigate = useNavigate();
  const { role, company } = useRoleContext();

  const isCarrier = company?.company_type === "CARRIER";
  const companyId = role?.company?.id ?? null;

  // Shares the SWR key the top-nav Banner already fetches, so this adds no
  // extra request. Non-carriers pass null and trigger no fetch.
  const { companyProfile } = useCompanyProfile(isCarrier ? companyId : null);

  // External (partner-invited) carriers keep a friction-free nav, matching
  // FillCarrierProfileBanner (#2307); they still get the in-page
  // CarrierProfileCompletionAlert. The badge stays hidden while the profile is
  // loading (is_complete undefined) so it never flashes.
  const showIncompleteBadge =
    companyProfile?.profile_completion?.is_complete === false &&
    !company?.is_external_carrier;

  if (isCarrier && companyId != null) {
    return (
      <Tooltip
        title={
          showIncompleteBadge
            ? "Complete your carrier profile"
            : "Company Profile"
        }
        placement="right"
        TransitionComponent={Zoom}
      >
        <IconButton
          color="inherit"
          onClick={() => navigate(NAV_ROUTES.companyProfile(companyId))}
        >
          <Badge
            variant="dot"
            color="warning"
            invisible={!showIncompleteBadge}
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                width: 13,
                height: 13,
                borderRadius: "50%",
              },
            }}
          >
            <SupervisedUserCircleIcon fontSize="large" />
          </Badge>
        </IconButton>
      </Tooltip>
    );
  }

  return <div />;
}
